import posthog from "posthog-js";

/**
 * `posthog.capture()`, but a throw inside it can never escape.
 *
 * Several call sites in the enquiry/quiz funnel sit inside a
 * business-logic `try` block — a capture call that throws (a posthog-js
 * plugin error, a malformed payload) would otherwise be caught by that
 * block's own `catch` and misreport a successful action as failed (e.g.
 * `useQuizWizardController.ts`'s `submitStep` would show a network error and
 * refuse to advance the step, even though the PATCH already succeeded
 * server-side), or — inside a bare `useEffect` with no surrounding try/catch
 * — trip the nearest error boundary. Analytics must never be able to break
 * the flow it's measuring.
 */
export function safeCapture(event: string, properties?: Record<string, unknown>): void {
  try {
    posthog.capture(event, properties);
  } catch {
    // Swallowed deliberately — see module doc above.
  }
}
